import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Overview } from './pages/Overview';
import { Prospects } from './pages/Prospects';
import { ProspectDetail } from './pages/ProspectDetail';
import { ApprovalQueue } from './pages/ApprovalQueue';
import { Replies } from './pages/Replies';
import { Opportunities } from './pages/Opportunities';
import { Suppression } from './pages/Suppression';
import { Settings } from './pages/Settings';

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/prospects" element={<Prospects />} />
        <Route path="/prospects/:id" element={<ProspectDetail />} />
        <Route path="/approval" element={<ApprovalQueue />} />
        <Route path="/replies" element={<Replies />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/suppression" element={<Suppression />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}
